var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Отзывы ("+_vm._s(_vm.commentsCount)+")")]),_c('div',{attrs:{"id":"hostel-comments"}})])}
var staticRenderFns = []

export { render, staticRenderFns }